import { FormikProps } from "formik";
import { useContext } from "react";
import {
  EventReportWithDataFileRow,
  SubmitProgramReport,
} from "../../../../../../generated/data-contracts";
import { LicenseesUtils, api } from "../../../../../../utils";
import Nbsp from "../../../../../../utils/nbsp";
import {
  AvisEditableList,
  IAvisEditableListFieldConfig,
  IRowState,
} from "../../../../../shared/components/editableList";
import {
  AvisFileDownload,
  AvisFileUpload,
  AvisSection,
} from "../../../../../shared/components/form";
import { AvisContext } from "../../../../../shared/context/AvisContext";

interface IProgramReportFilesProps {
  bag: FormikProps<SubmitProgramReport>;
  bagField: keyof SubmitProgramReport;
  disabled: boolean;
  loading: boolean;
  allowedFileFormats: string[] | undefined;
}
export function ProgramReportFiles(props: Readonly<IProgramReportFilesProps>) {
  const { bag, bagField, disabled, loading, allowedFileFormats } = props;
  const { res } = useContext(AvisContext);

  const urlParams = LicenseesUtils.getUrlParams();
  const fieldCollection: IAvisEditableListFieldConfig<
    IRowState<EventReportWithDataFileRow>
  >[] = [
    {
      name: "fileName",
      width: "80%",
      transformViewValue: (_fieldValue, rowValue) => {
        if (
          !urlParams.licenseId ||
          !rowValue.portal_LicenseDocumentId ||
          rowValue.rowState === "Delete"
        )
          return <div>{rowValue.fileName}</div>;

        return (
          <AvisFileDownload
            callApiOnClick={() =>
              api.licenseesGetLicenseDocument(
                urlParams.licenseId as number,
                rowValue.portal_LicenseDocumentId as number,
                {
                  format: "arraybuffer",
                },
              )
            }
            fileName={rowValue.fileName || ""}
          />
        );
      },
      renderField: (field, prefix, i, val, onChange) => {
        if (val.fileName && !val.base64Data && val.portal_LicenseDocumentId) {
          if (!urlParams.licenseId || !val.portal_LicenseDocumentId)
            return <div>{val.fileName}</div>;

          return (
            <AvisFileDownload
              callApiOnClick={() =>
                api.licenseesGetLicenseDocument(
                  urlParams.licenseId as number,
                  val.portal_LicenseDocumentId as number,
                  {
                    format: "arraybuffer",
                  },
                )
              }
              fileName={val.fileName}
            />
          );
        }

        return (
          <AvisFileUpload
            name={`${prefix}.${i}.${field.name}`}
            disabled={disabled}
            onChange={onChange}
            allowedFormats={allowedFileFormats}
          />
        );
      },
    },
    {
      name: "portal_LicenseDocumentId",
      width: "20%",
      forceViewMode: true,
      transformViewValue: () => {
        return <Nbsp />;
      },
    },
  ];

  return (
    <AvisSection
      classNameIn="file-collection"
      title={res("label_UploadFiles")}
      textToDisplayKey="portal_LIC_ProgramReport_3"
    >
      <AvisEditableList<SubmitProgramReport, EventReportWithDataFileRow>
        bag={bag}
        bagField={bagField}
        initValue={{ fileName: "", base64Data: "" }}
        maxRows={5}
        hideEdit
        fields={fieldCollection}
        disabled={disabled}
        loading={loading}
        view="table"
      />
    </AvisSection>
  );
}
